export default "__VITE_ASSET__188895b6__"